import * as apiActions from "@configuratorware/configurator-frontendgui/App/Reducers/Actions";
import { Category } from "../../Types/Types";

export const actions = {
  RECEIVE_CATEGORIES: "RECEIVE_CATEGORIES",
  SET_SELECTED_CATEGORY_ID: "SET_SELECTED_CATEGORY_ID",
};

export const receiveCategories = (categories: Category[]) => ({
  type: actions.RECEIVE_CATEGORIES,
  categories
});

export const setSelectedCategoryId = (categoryId: number) => ({
  type: actions.SET_SELECTED_CATEGORY_ID,
  categoryId,
});

export const fetchCategories = () => {
  return apiActions.fetchData("productoverview", receiveCategories);
};
